import { useSuspenseQuery } from '@tanstack/react-query';
import { IFeatureFlagrResponse } from 'services/featureFlagr/types';
import { getUserHasFeature } from 'services/featureFlagr';

export const useFlagr = (flagId: number) => {
  const { data } = useSuspenseQuery<IFeatureFlagrResponse>({
    queryKey: ['flagr', flagId],
    queryFn: () => getUserHasFeature(flagId).catch(() => ({ access: false })),
    staleTime: Infinity,
  });

  return {
    hasAccess: data.access,
  };
};
